import { jsx as e } from "react/jsx-runtime";

import { cloneElement as o } from "react";

import r from "../FormControlLabel/index.js";

import l from "../../hooks/useId/index.js";

import t from "../../utils/classNames/index.js";

const i = {
    top: "grid-cols-1",
    left: "grid-cols-[auto,min-content]",
    right: "grid-cols-[min-content,auto]"
}, a = {
    error: "text-fuchsia-800",
    normal: "text-neutral-600"
}, n = ({id: n, children: s, className: d, consciouslyIgnoreLabel: c, label: p, labelVariant: m = "normal", labelPlacement: b = "top", labelTooltipContent: u, LabelProps: h, helper: f, helperVariant: g = "normal", HelperProps: w, ...x}) => {
    const y = l(s.props.id || n), v = `${y}label`, L = `${y}helper`;
    if ("production" !== process.env.NODE_ENV && (h?.id && console.warn("Label id will be overriden. Got: " + h.id), 
    w?.id && console.warn("Helper id will be overriden. Got: " + w.id), n && s.props.id && console.warn(`Both FormControl.id(#${n}) and child input id(#${s.props.id}) are provided. Child input id will be preferred`), 
    !c)) switch (p) {
      case "":
      case null:
      case void 0:
        throw new Error("FormControl: Labels are needed for accessibility. \t\t\t\t\t\tIf you 100% want to render without label - use 'consciouslyIgnoreLabel' prop");
    }
    const N = c ? null : e(r, {
        as: "label",
        id: v,
        htmlFor: y,
        tooltipContent: u,
        tooltipBeforeLabel: "left" === b,
        className: "disabled" === m ? "text-neutral-600" : "",
        ...h,
        children: p
    }, 0 /* KEYS.LABEL */), C = o(s, {
        key: s.key ?? 1 /* KEYS.INPUT */ ,
        id: y,
        "aria-labelledby": N ? v : void 0,
        "aria-describedby": f ? L : void 0,
        labelId: N ? v : void 0
    }), I = f && e("div", {
        className: t("typography-small col-span-full leading-tight", a[g]),
        ...w,
        id: L,
        role: "error" === g ? "alert" : w?.role,
        children: f
    }, 2 /* KEYS.HELPER */);
    return e("div", {
        className: t(
        /*
                    Reason to use gap-y-[10px] instead of gap-xs
                    Hayden wanted to increase offset between label and input while creating design for fast-forms
                */
        "gap-x-xs grid grid-flow-row place-content-start items-center gap-y-[10px]", i[b], d),
        ...x,
        children: "right" === b ? [ C, N, I ] : [ N, C, I ]
    });
};

export { n as default };
//# sourceMappingURL=index.js.map
